import category from "./category.json";
import post from "./post.json";
export default {
  category,
  post,
};
